export enum TableColumn {
  messageType = 'messageType',
  subscriptionPolicy = 'subscriptionPolicy',
  status = 'status',
  subscriptionAction = 'subscriptionAction',
}
